import React, { Component } from 'react';
import {Modal,Toast} from "antd-mobile";
import axios from "axios";
import url from "url";
import storage from "../model/storage";
import Single from "./Single";
import Multi from "./Multi";
import Topic from "./Topic";
import Completion from "./Completion";
import "../assects/css/home.css";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      examId:"",
      paperId:"",
      userId:"",
      isDid:false,
      isShow:false,
      
      imgSrc:""
    };
  }
  
  onRef = (ref) => {

    this.child = ref

}
  componentDidMount(){
    
    let that = this;
    let examId = url.parse(that.props.location.search, true).query.examId;
    let paperId = url.parse(that.props.location.search, true).query.paperId;
    
    if (examId === ""||examId===undefined||paperId === ""||paperId===undefined) {
      Toast.info('获取试卷信息错误!', 1);
    }else{

    
      axios.get(storage.baseUrl+'/prePaper', {
        params: {
          examId: examId,
          paperId: paperId,
         
        }
      })
        .then(function (response) {
          // handle success
          //console.log(response);
          let questionDates=response.data.questionDates;
         
          //console.log(response.data);
          that.setState({
            questionDates:questionDates
          })
         
         
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })

      }
  
  }
  
  onClose =() => {
    this.setState({
     imgShow: false
    });
  }
 imgShow=(e)=>{
  //console.log(e);
  if(e.target.nodeName==="IMG"){
    this.setState({
      imgShow:true,
      imgSrc:e.target.src
    })
  }
 }
  

  componentDidUpdate(){
    
  }
  
  
  subCard=(questionId,optChoose,correctness,score)=>{
    
    

  }
 
  render() {
   
    return (
      <div>
        <Modal
          className="imgCon"
            visible={this.state.imgShow}
            transparent
            maskClosable={true}
            onClose={this.onClose}
            title="查看图片"
            footer={[{ text: 'Ok', onPress: () => { console.log('ok'); this.onClose();} }]}
            wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            
          >
          <img style={{width:'100%'}} src={this.state.imgSrc} alt="" />
          </Modal>
      
      <div className="gf_con" >
          {/* <p className="gf_T">注意事项：本试卷来自考生回忆，不对真实性负责，仅供参考</p> */}
         <div className="qus_con">
         {
             this.state.questionDates&&this.state.questionDates.map((value,key)=>{
               if(value.questionType==="1001"){
                 return(
                  <Single  data={[value]} ansShow={true}   key={key} Skey={key+1} subCard={this.subCard} imgShow={this.imgShow} title='单项选择题' listXX="单选"></Single>
                 )
               }else if(value.questionType==="1002"){
                return(
                <Multi data={[value]} key={key} ansShow={true} Skey={key+1} subCard={this.subCard} imgShow={this.imgShow} title='多项选择题' listXX="多选"></Multi>
               
                )
              }else if(value.questionType==="1016"){
                return(
                <Multi data={[value]} key={key} ansShow={true} Skey={key+1} subCard={this.subCard} imgShow={this.imgShow} title='不定项选择题' listXX="不定项选择"></Multi>
               
                )
              }else if(value.questionType==="1003"){
                return(
                  <Single data={[value]}  ansShow={true} key={key} Skey={key+1}  subCard={this.subCard} imgShow={this.imgShow} title='判断题' isDan="1" listXX="判断"></Single>
               
                )
              } else if(value.questionType==="1013"){
                return(
                  <Completion data={[value]} ansShow={true}  key={key} Skey={key+1}  subCard={this.subCard} imgShow={this.imgShow}  listXX="填空"></Completion>
               
                )
              }
              else{
                return(
                  <Topic data={[value]}  ansShow={true} key={key} Skey={key+1}  subCard={this.subCard} imgShow={this.imgShow} title='辨析题' listXX="综合"></Topic>
               
                )
              }
             })
           }
          </div>
      
      </div>
       </div>
    );
          
  }
}

export default Home;
